import { Box, Grid } from "@material-ui/core";
import SkeletonLoader from 'custom-components/skeletonLoader';

import React from 'react';

const TemplatesLoader = () => {
    return (
        <Box>
            <SkeletonLoader height="20px" width="120px" variant="text" />
            <SkeletonLoader height="42px" width="200px" variant="text" mt="10px" />
            <SkeletonLoader height="20px" width="100%" variant="text" mt="10px" />
            <SkeletonLoader height="20px" width="120px" variant="text" mb="30px" />
            <Grid container spacing={2}>
                {[1, 2, 3, 4].map((item) => (
                    <Grid item xs={12} lg={3} key={item}>
                        <SkeletonLoader height="180px" width="100%" variant="rect" />
                    </Grid>))}
            </Grid>
        </Box>
    )
}

export default TemplatesLoader;